import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    heading: p => p.accentWhite,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    background: p => p.tertiaryDark,
    icon: p => `rgba(${hexToRgb(p.primaryLight)}, 1)`,
    backgroundGradient: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.8)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryLight,
    icon: p => `rgba(${hexToRgb(p.primaryDark)}, 1)`,
    backgroundGradient: p => `rgba(${hexToRgb(p.tertiaryLight)}, 0.8)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    gradientColorFrom: p => p.primaryDark,
    gradientColorTo: p => p.primaryLight,
    paragraph: p => p.tertiaryDark,
    background: p => p.tertiaryExtraLight,
    icon: p => `rgba(${hexToRgb(p.primaryDark)}, 1)`,
    backgroundGradient: p => `rgba(${hexToRgb(p.tertiaryExtraLight)}, 0.9)`
  }
}
